export default {
  OBJ_ATTENTE: 0,
  OBJ_ATTEINT: 1,
  OBJ_NON_ATTEINT: 2,

  TXT_OBJ_ATTENTE: 'En attente',
  TXT_OBJ_ATTEINT: 'Atteint',
  TXT_OBJ_NON_ATTEINT: 'Non atteint',
};
